import React from "react";
import Hero from "../components/Hero";
import RecipeSection from "../components/Recipe/RecipeSection";
const Home: React.FC = () => {
  return (
    <>
      {" "}
      <Hero />
      <RecipeSection />
    </>
  );
};

export default Home;
